import { API, graphqlOperation } from 'aws-amplify'

export interface BayLocation {
    Location: string
    BayID: number
}

const GET_BAYS = `query getBayLocations {
    getBayLocations {
        Location
        BayID
    }
}`

interface GET_BAYS_RESULT {
    data: {
        getBayLocations: BayLocation[]
    }
}

export async function GetBayLocations(): Promise<BayLocation[]> {
  let BayLocations: BayLocation[] = []
  try {
    const result = (await API.graphql(graphqlOperation(GET_BAYS, { }))) as GET_BAYS_RESULT
    BayLocations = result.data.getBayLocations
  } catch (e) {
    console.log(e)
  }
  return BayLocations
}
